import { render, staticRenderFns } from "./ApplicableVatPricing.vue?vue&type=template&id=12024417&"
import script from "./ApplicableVatPricing.vue?vue&type=script&lang=ts&"
export * from "./ApplicableVatPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports